import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";

import Loader from "../../atoms/Loader";
import Logotype from "../../atoms/Logotype";
import PageTitle from "../../atoms/PageTitle";
import ProgressBar from "../../atoms/ProgressBar";
import { APPLICATION_ROUTES, PAGE_TITLES } from "../../../constants";
import { StoreContext } from "../../../contexts";
import { ACTIONS } from "../../../store";
import useSteps from "./useSteps";
import { getTranslationKeyOfError } from "./utilities";
import { useTranslation } from "react-i18next";
import { LOCALES, useLocale } from "../../../hooks/useLocale/useLocale";

const SignUpPage = observer(() => {
  const {
    allStepsLength,
    currentStepNumber,
    setStepIndex,
    fields,
    isNotValid,
    Step,
    onSubmit,
  } = useSteps();
  const { authorization } = useContext(StoreContext);
  const { t } = useTranslation();
  const locale = useLocale(); // Get the locale from domain
  const isHeb = locale === LOCALES.HE; // Check if Hebrew (RTL)
  const ERROR_MESSAGE = t(getTranslationKeyOfError(authorization.errorSignUp));

  useEffect(() => {
    return () => {
      authorization.clearError(ACTIONS.AUTHORIZATION.SIGN_UP);
    };
  }, []);

  return (
    <>
      <PageTitle value={PAGE_TITLES.SIGN_UP} />
      <main className="bg-gold-gradient--horizontal c-grey-dark text-m">
        <div className="wrapper-s wrapper-vertical-s-a d-flex fd-column ai-center minh-100vh">
          <div>
            <Logotype url={isHeb ? APPLICATION_ROUTES.MY_MAOR_MAIN : "/"} />
          </div>
          <div className="mt-08 w-100p" style={{ maxWidth: "300px" }}>
            <ProgressBar
              current={currentStepNumber}
              length={allStepsLength + 1}
            />
          </div>
          <div className="mt-10 w-100p mb-05">
            <Step
              {...fields}
              error={authorization.errorSignUp && ERROR_MESSAGE}
              isNotValid={isNotValid || authorization.isLoadingSignUp}
              setStepIndex={setStepIndex}
              onSubmit={onSubmit}
            />
          </div>

          {authorization.isLoadingSignUp && (
            <div className="mt-04">
              <Loader />
            </div>
          )}
        </div>
      </main>
    </>
  );
});

export default SignUpPage;
